import { Fragment } from "react";

const AWS_S3_BUCKET_URL = process.env.REACT_APP_AWS_S3_BUCKET_URL;

export const OfferInfoInTable = (props) => {
  const logo = props.offer.logo || "";
  const logoSrc = /^https?:\/\//i.test(logo)
    ? logo
    : `${AWS_S3_BUCKET_URL}/advertiser-logos/${logo}`;

  return (
    <Fragment>
      <span>
        <div className="d-flex align-items-center">
          <div className="flex-shrink-0 me-3">
            <div className="avatar-sm bg-light rounded p-1">
              <img
                src={logoSrc}
                alt={props.offer.offerName}
                className="img-fluid d-block"
              />
            </div>
          </div>
          <div className="flex-grow-1">
            <h5 className="fs-14 mb-1">
              <a
                href={props.offer.website}
                target="_blank"
                rel="noreferrer"
                className="text-dark"
              >
                {props.offer.offerName}
              </a>
            </h5>
            <p className="text-muted mb-0">{props.offer.referenceId}</p>
          </div>
        </div>
      </span>
    </Fragment>
  );
};
